import React from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { RevealStagger, StaggerItem, Reveal } from "@/components/Reveal";
import { REELS, DOCTOR } from "@/data/content";

const InstagramReels = () => {
  return (
    <section id="instagram" data-testid="instagram-section" className="relative bg-brand-light py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand flex items-center gap-2">
              <Instagram className="w-4 h-4" /> From our Instagram
            </p>
            <h2 className="font-heading font-extrabold text-[#0b2c4d] text-4xl md:text-5xl tracking-tight mt-3 leading-tight">
              Spine health, explained on reels
            </h2>
            <p className="mt-5 text-lg text-slate-500">
              Short, practical videos from Dr. Arun Reddy M on conditions, treatments and recovery.
            </p>
          </div>
          <a
            href={DOCTOR.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-link"
            className="inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-hover text-white px-5 py-3 text-sm font-semibold transition-colors shrink-0 shadow-lg shadow-brand/20"
          >
            <Instagram className="w-4 h-4" />
            Follow on Instagram
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </Reveal>

        <RevealStagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REELS.map((r, i) => (
            <StaggerItem key={r.id}>
              <div
                data-testid={`reel-card-${i}`}
                className="glass-card rounded-2xl overflow-hidden hover:-translate-y-1.5 hover:shadow-lg transition-all duration-300"
              >
                <div className="relative w-full bg-black" style={{ height: 620 }}>
                  <iframe
                    data-testid={`reel-iframe-${i}`}
                    title={r.title}
                    src={`https://www.instagram.com/reel/${r.id}/embed`}
                    className="absolute inset-0 w-full h-full"
                    frameBorder="0"
                    scrolling="no"
                    allow="encrypted-media; picture-in-picture; clipboard-write"
                    loading="lazy"
                  />
                </div>
              </div>
            </StaggerItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
};

export default InstagramReels;
